import { request } from "../request";

/**
 * 发送邮件验证码
 * @param toEmail 发送邮件
 */
export function SendEmailCodeAsync(toEmail: string) {
    return request({
        url: '/Email/SendEmailCode',
        method: "get",
        params: {
            toEmail
        }
    });
}